import { Directive, Input, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';

import { PermissaoAcessoService } from '../services/permissao/permissao-acesso.service';

/**
 * Mostra o elemento, exceto quando a ação do usuário na funcionalidade é "Bloquear e ocultar" (3).
 * Nas ações 2 e 4 o elemento aparece e quem decide é o clique (verificarAcesso).
 * Uso: <button *appSePermitido="FuncionalidadeSistemaId.X">...</button>
 */
@Directive({
    selector: '[appSePermitido]',
    standalone: true
})
export class SePermitidoDirective implements OnInit {
    @Input('appSePermitido') funcionalidadeId!: number;

    constructor(
        private template: TemplateRef<unknown>,
        private container: ViewContainerRef,
        private permissaoAcesso: PermissaoAcessoService
    ) { }

    async ngOnInit(): Promise<void> {
        const oculta = await this.permissaoAcesso.estaOculta(this.funcionalidadeId);
        if (!oculta) this.container.createEmbeddedView(this.template);
    }
}
